import { render, staticRenderFns } from "./Third-detail.vue?vue&type=template&id=564e1894&scoped=true"
import script from "./Third-detail.vue?vue&type=script&lang=js"
export * from "./Third-detail.vue?vue&type=script&lang=js"
import style0 from "./Third-detail.vue?vue&type=style&index=0&id=564e1894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e1894",
  null
  
)

export default component.exports